import session from './session'
import {ENDPOINT} from './index'

export default {
  filterAnnualOrderReport (filterData, page, pageSize) {
    return session.post(
      ENDPOINT + '/report/filter_annual_order_report/', {
        page: page,
        page_size: pageSize,
        filter: filterData
      }
    )
  },
  filterBadDebtReport (filterData, page, pageSize) {
    return session.post(ENDPOINT + '/report/filter_bad_debt_report/', {
      page: page,
      page_size: pageSize,
      filter: filterData
    })
  },
  filterReport (filterData, page, pageSize) {
    return session.post(ENDPOINT + '/report/filter_report/', {
      page: page,
      page_size: pageSize,
      filter: filterData
    })
  },
  filterOrderStatusReport (filterData) {
    return session.post(ENDPOINT + '/report/filter_order_status_report/', {
      filter: {
        order: filterData
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/report.js